<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование организации" : "Добавление организации"'
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab Организация
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs6)
              v-text-field(
                :error='errors.has("name")'
                :error-messages='errors.first("name")'
                v-model='item.name'
                label='Название / Торговое название'
              )
            v-flex(xs6)
              s-org-spheres-picker(
                :error='errors.has("sphere_id")'
                :error-messages='errors.first("sphere_id")'
                v-model='item.sphere_id'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("full_name")'
                :error-messages='errors.first("full_name")'
                v-model='item.full_name'
                label='Полное название / Юридическое название'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("site")'
                :error-messages='errors.first("site")'
                v-model='item.site'
                label='Сайт'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("email")'
                :error-messages='errors.first("email")'
                v-model='item.email'
                label='Email'
              )
            v-flex(xs12)
                span(class='subheading font-weight-medium') Контактные телефоны
                v-btn(@click='onAddContact' small flat color='primary')
                  v-icon(small left) add
                  | Добавить
            v-flex(xs12)
              v-layout(wrap)
                v-flex(
                  v-for='(phone, index) in phones'
                  :key='index'
                  xs12 md3
                )
                  s-phone-input(
                    @input='onContactChange($event, index)'
                    @click:append='onRemoveContact(index)'
                    :value='phone'
                    label='Номер телефона'
                    append-icon='close'
                  )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("about")'
                :error-messages='errors.first("about")'
                v-model='item.about'
                label='Описание'
              )
            v-flex(xs12 sm4)
              s-image-upload(
                :src='item.avatar_url'
                v-model='item.avatar'
                label='Логотип'
              )
        v-card-actions(class='large')
          v-spacer
          s-back-btn
          v-btn(
            :loading='isLoading'
            @click='onSave'
            color='primary'
            depressed
          ) Сохранить
      v-tab Офисы
      v-tab-item(:transition='false' :reverse-transition='false')
        s-offices-list(
          @edit='editOffice'
          @delete='deleteOffice'
          :list='item.offices'
        )
      v-tab Акции
      v-tab-item(:transition='false' :reverse-transition='false')
        s-actions-list(
          @edit='editAction'
          @delete='deleteAction'
          @status='changeActionStatus'
          :list='item.actions'
        )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    item: {},
    active: 0,
    phones: [null],
    maxPhones: 10
  }),

  created() {
    this.updateItem()
  },

  beforeRouteEnter(to, from, next) {
    next(vm => (vm.active = parseInt(to.query.tab) || 0))
  },

  methods: {
    async updateItem() {
      if (this.id) {
        let { data } = await this.fetchSingle({ id: this.id })
        this.item = data
        this.phones = this.item.phones.split(/,/)
      }
    },

    async onSave() {
      let data = this.createFormData()

      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Компания сохранена')
        this.$router.push({ name: 'Partner.Organizations' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    createFormData() {
      let data = new FormData()
      if (this.phones.length) {
        this.item.phones = this.phones.filter(c => c).join(',')
      } else {
        this.item.phones = null
      }
      Object.keys(this.item).forEach(key => {
        data.append(key, this.item[key])
      })
      return data
    },

    onContactChange(value, index) {
      this.phones[index] = value
    },

    onRemoveContact(index) {
      this.phones.splice(index, 1)

    },

    onAddContact() {
      if (this.phones.length < this.maxPhones) {
        this.phones.push(null)
      }
    },
    editOffice(id) {
      this.$router.push({
        name: 'Partner.Offices.Edit',
        params: { organizationId: this.id, id }
      })
    },

    async deleteOffice(id) {
      if (!this.isOfficeLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.destroyOffice({ id })
          this.updateItem()
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    editAction(id) {
      this.$router.push({
        name: 'Partner.Actions.Edit',
        params: { organizationId: this.id, id }
      })
    },

    async deleteAction(id) {
      if (!this.isActionLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.destroyAction({ id })
          this.updateItem()
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    async changeActionStatus({ item, status }) {
      if (!this.isActionLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.updateActionStatus({ id: item.id, status })
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка смены статуса')
        }
      }
    },

    ...mapActions('partner/organizations', ['fetchSingle', 'update', 'create']),
    ...mapActions('partner/offices', { destroyOffice: 'destroy' }),
    ...mapActions('partner/actions', {
      destroyAction: 'destroy',
      updateActionStatus: 'changeStatus'
    })
  },

  computed: {
    ...mapGetters('partner/organizations', ['isLoading']),
    ...mapGetters('partner/offices', { isOfficeLoading: 'isLoading' }),
    ...mapGetters('partner/actions', { isActionLoading: 'isLoading' })
  },

  watch: {
    active(tab) {
      this.$router.replace({
        query: {
          tab
        }
      })
    }
  }
}
</script>
